import { FC, Fragment } from 'react'
import { formatDate } from '@core/utils/time'
import Typography from '@/ui/components/typography'
import { InfoItem } from '@ui/drawer/common/infoItem'

type TAssetInfoBaseProps = {
    asset: TAsset
}

const AssetInfoBase: FC<TAssetInfoBaseProps> = ({ asset }) => {
    const {
        hostname,
        isp,
        ip,
        last_seen: lastSeen,
        shared_ip: sharedIp,
    } = asset

    return (
        <>
            {lastSeen && (
                <InfoItem title="Last detected" dataTestId="last-detected">
                    {formatDate(lastSeen)}
                </InfoItem>
            )}
            <InfoItem
                title="Host"
                dataTestId='hostname'
            >
                {hostname || '-'}
            </InfoItem>
            <InfoItem title="ISP" dataTestId='isp'>
                {isp || '-'}
            </InfoItem>
            {sharedIp && <InfoItem title="Shared IP">Yes</InfoItem>}
            {ip && ip.length > 0 && (
                <InfoItem title="IP">
                    {ip.map((address: string, idx: number) => (
                        <Fragment key={address}>
                            {idx > 0 && <br />}
                            <Typography
                                variant="s-regular"
                                color="inherit"
                                component="span"
                            >
                                {address}
                            </Typography>
                        </Fragment>
                    ))}
                </InfoItem>
            )}
        </>
    )
}

export default AssetInfoBase
